import { cn } from '../../lib/cn';
import { STATI, statoPartecipante } from '../../lib/eventi/stati';
import type { PartecipanteEvento } from '../../lib/eventi/tipi';

type Props = {
  partecipante: Pick<PartecipanteEvento, 'richiesta_at' | 'assegnazione_stato'>;
  className?: string;
};

/** Lo stato di un partecipante come pastiglia colorata, con la spiegazione al passaggio del mouse. */
export function BadgeStato({ partecipante, className }: Props) {
  const stato = STATI[statoPartecipante(partecipante)];
  return (
    <span
      title={stato.spiegazione}
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap',
        stato.badge,
        className,
      )}
    >
      {stato.etichetta}
    </span>
  );
}
